import { render, staticRenderFns } from "./servico.vue?vue&type=template&id=4c73e6f1&scoped=true&"
import script from "./servico.vue?vue&type=script&lang=js&"
export * from "./servico.vue?vue&type=script&lang=js&"
import style0 from "./servico.vue?vue&type=style&index=0&id=4c73e6f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c73e6f1",
  null
  
)

export default component.exports